/**
 * Site Header Search
 * -----------------------------------------------------------------------------
 * 
 * Mimicking a feature from `_topbar.js`, but not enough to warrant placement in
 * `vendor-extensions`.
 */

// Imports.
const $ = require( 'jquery' );


// Toggle between Search and Close icons.
$( '.toggle-search' ).on( 'click', function ( e ) {

  const $this   = $( this );
  const $parent = $this.parent();

  $parent.toggleClass( 'topbar__item--active', !$parent.hasClass( 'topbar__item--active' ) );

} );